
























import {Component, Vue} from 'vue-property-decorator'
import * as Helper from '@/helpers'
// @ts-ignore
import Pdf from 'vue-pdf'

export interface DisplayOptions {
  src: string
  alt?: string
  showDownload?: boolean
  filename?: string
}

@Component({components: {Pdf}})
export default class ModalImageDisplay extends Vue {
  options: DisplayOptions | null = null

  Helper = Helper

  async openEvent(options: DisplayOptions) {
    this.$emit('open')
    this.options = options
  }

  closeEvent() {
    this.options = null
    this.$emit('close')
  }

  download() {
    if (!this.options) return

    if (!this.options.filename) {
      Helper.openUrl(this.options.src)
      return
    }

    const filename = this.options.filename
    const fileInformation = this.getFileInformation(this.options.src)
    const url = this.options.src + '?t=' + new Date().getTime()

    fetch(url, {
      method: 'GET',
    }).then((resp) => {
      return resp.blob()
    }).then((blob) => {
      const newBlob = new Blob([blob], { type: 'application/octet-stream' })
      const data = window.URL.createObjectURL(newBlob)
      const link = document.createElement('a')

      link.href = data

      link.download = filename.replace('@filename', fileInformation.name.replace('_', ''))
          + '.' + fileInformation.extension

      link.dispatchEvent(new MouseEvent('click'))

      window.URL.revokeObjectURL(data)
    })
  }

  getFileInformation(fileName: string) {
    const fileAndExtension = fileName.match(/(.+)\.(\w+)$/)

    if (fileAndExtension) {
      const matchFilename = fileAndExtension[1].match(/[^/]+$/)
      const filename = matchFilename ? matchFilename[0] : ''

      return {
        name: filename,
        extension: fileAndExtension[2],
      }
    }

    return {
      name: fileName,
      extension: '',
    }
  }

  close() {
    this.$modal.close('imageDisplay')
  }
}
